module.exports = __webpack_public_path__ + "media/Hymn of Souls (Temple).c9e40086.mp3";